import _ from 'lodash'
import { PARSERS, parsers as parserDefs } from './parsers'

/**
 * Given a string and a regexp, returns all matches and returns remainder.
 *
 * @param {string} s          string to extract from
 * @param {RegExp} regexp     regular expression to identify parts to extract
 * @param {function} isValid  function that takes a value and returns true if valid
 *
 * @returns object with terms extracted and remainder string
 */
const extract = (s, { regexp, validator = () => true }) => {
  const regexpMatches = s.match(regexp) || []

  const matches = regexpMatches.reduce((acc, match) => {
    if (
      validator(match) &&
      !acc.find(item => item.toUpperCase() === match.toUpperCase())
    ) {
      acc.push(match)
    }
    return acc
  }, [])

  let remainder = s
  matches.forEach(match => {
    remainder = remainder.replace(new RegExp(match, 'gi'), '')
  })

  return {
    matches,
    remainder,
  }
}

/**
 * Given a free form query string, look for matches on dates, times, etc.
 *
 * @param {string} query      text of free form query
 * @param {array} parserIds   list of parsers to use - default to all available
 */
const parseQueryString = (query, parserIds = Object.values(PARSERS)) => {
  const terms = {}
  let s = query

  if (_.difference(parserIds, Object.values(PARSERS)).length) {
    throw new Error('Invalid parser specified.')
  }

  parserIds.forEach(parserId => {
    ;({ matches: terms[parserId], remainder: s } = extract(
      s,
      parserDefs[parserId]
    ))
  })
  return terms
}

parseQueryString.PARSERS = PARSERS
export default parseQueryString
